var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.719 12A8.718 8.718 0 0 1 12 20.719 8.718 8.718 0 0 1 3.281 12 8.72 8.72 0 0 1 12 3.281 8.72 8.72 0 0 1 20.719 12ZM12 13.758a1.617 1.617 0 1 0 0 3.234 1.617 1.617 0 0 0 0-3.234Zm-1.535-5.813.26 4.781a.422.422 0 0 0 .422.399h1.706c.224 0 .41-.175.422-.399l.26-4.781a.422.422 0 0 0-.42-.445h-2.23a.422.422 0 0 0-.42.445Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationCircle);
export default ForwardRef;